import { render, staticRenderFns } from "./GiftMom.vue?vue&type=template&id=bacff9fa&scoped=true&"
import script from "./GiftMom.vue?vue&type=script&lang=js&"
export * from "./GiftMom.vue?vue&type=script&lang=js&"
import style0 from "./GiftMom.vue?vue&type=style&index=0&id=bacff9fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bacff9fa",
  null
  
)

export default component.exports